import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getMovementPageData } from './api';
import type { MovementPageDataErrorCode } from './types';

export const {
	Context: MovementPageDataContext,
	Provider: MovementPageDataContextProvider,
	useContext: useMovementPageData,
	useAsyncData: useMovementPageDataFromApi,
	prefetchAsyncData: prefetchMovementPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'MovementPageDataContext',
	dataProperty: 'pageData',
	getData: getMovementPageData,
	getUniqueId: (slug) => slug,
	errorHandler: pageDataErrorHandler<MovementPageDataErrorCode>(),
});
